import { Vue } from 'vue-property-decorator';
import store from '@/store';
import Component from 'vue-class-component';
import { Filter } from '@/domain/interface/Filter';
import { namespace } from 'vuex-class';

const FilterStore = namespace('Filter');
@Component({
  store,
})
export default class FilterService extends Vue {
  getFilter(): Filter {
    return JSON.parse(JSON.stringify(this.filter));
  }

  @FilterStore.Action
  public updateFilter!: (filter: Filter) => void;

  @FilterStore.Action
  public resetFilter!: () => void;

  @FilterStore.Getter('getFilter')
  private readonly filter!: Filter;
}
